export const METHODS_BALANCE_OF = 'balanceOf'